/* projects/speaker-platform/src/app/molecules/create-planning-event/create-planning-event.component.scss */
/*# sourceMappingURL=create-planning-event.component-UPQWLJPX.css.map */
